
/**
 * Calculates the next service date based on a starting date and frequency.
 * @param {string|Date} baseDate The last service date or installation date.
 * @param {number|string} frequency The number of units.
 * @param {string} unit 'months' or 'years'.
 * @returns {string|null} The next service date in YYYY-MM-DD format.
 */
export const calculateNextServiceDate = (baseDate, frequency, unit = 'months') => {
    if (!baseDate || !frequency) return null;

    try {
        const date = new Date(baseDate);
        if (isNaN(date.getTime())) return null;

        const numFrequency = Number(frequency);
        if (isNaN(numFrequency)) return null;

        if (unit === 'years') {
            date.setFullYear(date.getFullYear() + numFrequency);
        } else if (unit === 'weeks') {
            date.setDate(date.getDate() + (numFrequency * 7));
        } else if (unit === 'days') {
            date.setDate(date.getDate() + numFrequency);
        } else {
            // Default to months
            date.setMonth(date.getMonth() + numFrequency);
        }

        return date.toISOString().split('T')[0];
    } catch (e) {
        console.error('Error calculating next service date:', e);
        return null;
    }
};
